module.exports = __webpack_public_path__ + "img/sendInvitations.185dc82c.svg";